import Socket from "./socket"
import config from "./config.js"
import axios from "./axios.js"
import VueLodash from "vue-lodash"
import lodash from "lodash"
import moment from "moment-timezone"
import sanitizeHTML from "sanitize-html"
import SecureLS from "secure-ls"
import isMobile from "ismobilejs"
import download from "./download"

export function globalPrototype(Vue) {
  Vue.prototype.$config = config
  Vue.prototype.$moment = moment
  Vue.prototype.$sanitize = sanitizeHTML
  Vue.prototype.$moment.locale("ja")
  Vue.prototype.$moment.tz("Asia/Tokyo")
  Vue.prototype.$sl = new SecureLS({isCompression: false, encryptionSecret: Vue.prototype.$config.storage.secret})
  Vue.prototype.$isMobile = isMobile(window.navigator)
  Vue.prototype.$download = download
  Vue.use(VueLodash, {name: "custom", lodash: lodash})
}

export function globalPrototypeWithState(Vue, store, router) {
  Vue.prototype.$socket = new Socket(store, config, Vue, router)
  Vue.prototype.$axios = new axios(store)
}
